export const subscriptionState = {
  allSubscriptions: [],
  selectedSubscription: null,
  subscriptionForm: false,
};
